import React from 'react';
import { Modal } from "react-bootstrap";
import '../beneficiary.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { useDispatch } from 'react-redux';
import { setBeneficiaryAuthType, setBeneficiaryRedgOption, updateChild } from '@store/actions/beneficiaryAction';

interface showModalProps {
    showModal: boolean;
    handleClose: (authType: string) => void;
};

const FaceAuthenticationOptionsModal = ({ showModal, handleClose }: showModalProps) => {
    const dispatch = useDispatch();
    
    const handleAuthClick = (authType: string) => {
        if (authType === 'Create_New_ABHA') {
            dispatch(setBeneficiaryRedgOption('Face_Authentication'));
            dispatch(setBeneficiaryAuthType('Face_Auth_Creation'));
        } else {
            dispatch(setBeneficiaryAuthType(authType));
        }
        handleClose(authType);
    };
    
    function handleBackClick(): void {
        handleClose('back');
    }

    function handleDiscardClick(): void {
        dispatch(updateChild('isChildRegistration', false));
        handleAuthClick('');
    }

    return (
        <>
            <div className="modal_auth_beneficiaries">
                <Modal
                    show={showModal}
                    onHide={() => handleAuthClick('')}
                    dialogClassName={'auth-card-modal'}
                    centered={true}
                    backdrop="static"
                >
                    <Modal.Header>
                        <div style={{ display: "flex", justifyContent: "space-between", gap: "400px" }}>
                            <div className="d-flex align-items-center beneficiary_back_button" onClick={handleBackClick}>
                                <i className="bi bi-arrow-left" style={{ cursor: "pointer" }}></i>
                                <span className="ms-1">Back</span>
                            </div>
                            <div className="d-flex align-items-center beneficiary_discard_button" onClick={handleDiscardClick}>
                                <span className="me-0">Discard</span>
                                <i className="bi bi-x"></i>
                            </div>
                        </div>
                    </Modal.Header>

                    <Modal.Body>
                        <div className='auth-container'>
                            <div className='auth-box' onClick={() => handleAuthClick('Create_New_ABHA')}>
                                <i className="bi bi-person-bounding-box" style={{ fontSize: '50px', color: '#656565' }}></i>
                                <div style={{ marginTop: '10px' }}>Create New ABHA</div>
                            </div>
                            <div className='auth-box' onClick={() => handleAuthClick('Find_Existing_ABHA')}>
                                <i className="bi bi-person-check" style={{ fontSize: '50px', color: '#656565' }}></i>
                                <div style={{ marginTop: '10px' }}>Find Existing ABHA</div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        </>
    );
};

export default FaceAuthenticationOptionsModal;
